/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="bcm-table">
    <div class="table-header">
      <div
        class="single-field d-none d-md-block"
        v-for="field in fields"
        :key="field.key"
      >
        <span>{{field.label}}</span>
      </div>
    </div>
    <div class="table-content">
      <table-list
      :items="items">
        <template v-for="(item, index) in items">
          <component :is="tileComponent" :key="index" :item="item" />
        </template>
      </table-list>
    </div>
  </div>
</template>

<script>
import TableList from './TableList'

export default {
  props: {
    fields: {
      type: Array,
      required: false,
      default: () => []
    },
    items: {
      type: Array,
      required: true
    },
    tileComponent: {
      type: Object,
      required: true
    }
  },
  components: {
    TableList
  }
}
</script>
